import React from 'react';

interface ExampleQuestionSkeletonProps {
  count?: number;
}

const ExampleQuestionSkeleton: React.FC<ExampleQuestionSkeletonProps> = ({ count = 3 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, idx) => (
        <div
          key={idx}
          className='w-full bg-white/60 backdrop-blur-sm border border-gray-200/60 rounded-lg p-3 sm:p-4 animate-pulse'
          style={{ animationDelay: `${idx * 150}ms` }}
        >
          <div className='flex items-start gap-2.5 sm:gap-3'>
            <div className='flex-shrink-0 mt-0.5'>
              <div className='w-4 h-4 bg-gray-300 rounded-sm' />
            </div>
            <div className='flex-1 space-y-2'>
              <div className='h-3 bg-gray-300 rounded w-full' />
              <div className='h-3 bg-gray-300 rounded w-5/6' />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ExampleQuestionSkeleton;
